export default __webpack_public_path__ + "static/tampons-product-2b5f77b28bd8287348142ab41b192bc4.png";